import type { TranslationDictionaryBuddy } from '@adornis/bh-matching-translation/translations.js';
import '@adornis/buchungsheld-theme/components/tr-icon.js';
import { ChemistryLitElement } from '@adornis/chemistry/chemistry-lit-element.js';
import { TranslationController } from '@adornis/translation-core/client/translation-controller.js';
import { html } from 'lit';
import { customElement, state } from 'lit/decorators.js';

@customElement('buddy-page-success-register')
export class MentoringPageSuccessRegister extends ChemistryLitElement {
  @state() protected readonly _translation = new TranslationController<TranslationDictionaryBuddy>(this);

  override render() {
    return html`
      <tr-flex horizontal space="sm" center crossaxis-center flex h100>
        <tr-h4> ${this._translation.translate('buddy', 'successfullyRegistered')} </tr-h4>
        <tr-icon size="xl"> check </tr-icon>
      </tr-flex>
    `;
  }
}
